/*
 * A helper component that conditionally wraps children in an anchor tag
 * This can be useful when we have 2 or more elements that may or may not
 * need to act as links.
 */

export function LinkOrStaticElem({
  label,
  newTab,
  onClick,
  url,
  children,
}: {
  label: string;
  newTab?: boolean;
  onClick?: () => void;
  url?: string;
  children: React.ReactNode;
}) {
  if (!url) return <>{children}</>;

  return (
    <a
      href={url}
      rel="noopener noreferrer"
      aria-label={label}
      onClick={onClick}
      target={newTab ? '_blank' : '_self'}
    >
      {children}
    </a>
  );
}
